// extracted by mini-css-extract-plugin
export default {"main":"BoardPage_main__Rmfss","container":"BoardPage_container__8-9Po","wrapper":"BoardPage_wrapper__DjjfJ","button":"BoardPage_button__46JCu"};